import { FC, useEffect, useState } from "react";
import { useSigma } from "react-sigma-v2";

const FocusNodeController: FC<{ node: string; isLayoutRunning: boolean }> = ({
  node,
  isLayoutRunning,
}) => {
  const sigma = useSigma();
  const [hasZoomed, setHasZoomed] = useState(false);

  useEffect(() => {
    if (hasZoomed) return;
    if (isLayoutRunning) return;

    const graph = sigma.getGraph();

    if (!graph.hasNode(node)) return;
    // debugger;
    const nodeDisplayData = sigma.getNodeDisplayData(node);
    const graphDimensions = sigma.getGraphDimensions();
    if (nodeDisplayData) {
      sigma.getCamera().animate(
        {
          x: nodeDisplayData.x,
          y: nodeDisplayData.y,
          // we zoom to see a box of X times the size of the node
          ratio: Math.max(
            (nodeDisplayData.size * 10) / graphDimensions.width,
            (nodeDisplayData.size * 10) / graphDimensions.height
          ) as number,
        },
        { duration: 500 }
      );
    }
    setHasZoomed(true);
  }, [isLayoutRunning]);
  return null;
};

export default FocusNodeController;
